<template>
  <div class="posts-grid">
    <div v-if="!posts.length">{{ $t(noData)}}</div>

    <post-grid-card
      v-for="post in posts"
      :key="post.id"
      :post="post"
    />
  </div>
</template>
<script>
import PostGridCard from "seu-frontend/modules/blog/components/PostGridCard.vue";

export default {
  name: "PostsGrid",
  components: {PostGridCard},
  props: {
    posts: {
      type: Array,
      required: true
    },
    noData: {
      type: String,
      default: 'blog.no_posts',
    }
  }
}
</script>
<style lang="scss">
@import "PostsGrid";
</style>
